import type { WindowDescriptor } from '@krp/client-runtime'

import type { OneCUiState } from '../../state'

/**
 * Окно «Структура 1С» (ONEC-STRUCT): организация → подразделение → склад
 * одной базы. `:rid` в адресе — структура двух баз не смешивается.
 */
export const ONEC_STRUCTURE_WINDOWS = {
  structure: 'onec.structure',
} as const

export const structureWindows: readonly WindowDescriptor<OneCUiState>[] = [
  {
    kind: ONEC_STRUCTURE_WINDOWS.structure,
    scope: 'resource',
    paths: ['/onec/:rid/structure'],
    label: 'Структура 1С',
    size: 'lg',
  },
]
